export default [
	{
		name: 'Reward',
		field: 'name',
		width: 'large'
	},
	{
		name: 'Description',
		field: 'description',
		width: 'large'
	},
	{
		name: 'Required Points',
		field: 'point_value',
		width: 'large',
		prepData: (data) => {
			return `${data.point_value} Points`;
		}
	},
	{
		name: 'Cashier Directions',
		field: 'cashier_directions',
		width: 'large'
	},
	{
		name: 'Active',
		field: 'is_active',
		isToggle: true,
		width: 'small'
	},
]



/** WEBPACK FOOTER **
 ** ./src/tables/plans.js
 **/